export default __webpack_public_path__ + "static/6-aac2ee5f8abcbec54bd5997b4d299201.png";